<template>
    <div>
        <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
            <CCol sm="12" @click="GoToSetting()">
                <img src="../assets/img/arrow-left.png" style="max-width:18px;" class="float-left"/>
                <h3 class="custom-18px-500 font-color-171717" style="padding-left: 25px;">Back</h3>
            </CCol>
            <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                <CRow class="m-2">
                    <CCol sm="12" md="4" lg="3" class="text-center p-2" v-for="button in buttons" :key="button.value">
                        <div :class="{'grey-background': activeButton === button.value, 'font-color-98A2B3': activeButton !== button.value}" @click="setActiveButton(button.value)" class="p-2">
                            {{ button.label }}
                        </div>
                    </CCol>
    
                </CRow>
            </CCard>
    
            <div v-if="activeButton === 'Financial'">
                <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                    <div class="p-2">
                        <h3 class="custom-18px-500 font-color-171717">Financial Approval</h3>
                        <hr class="custom-hr" />
                        <CRow>
                            <CCol sm="5">
                                <label class="custom-14px-500 font-color-171717">First Level Approval</label>
                                <v-select></v-select>
                            </CCol>
                            <CCol sm="5">
                                <label class="custom-14px-500 font-color-171717">Second Level Approval</label>
                                <v-select></v-select>
                            </CCol>
                            <CCol sm="2">
                                <div class="text-right mt-4">
                                    <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="openAddCompany()">
                                        Save</CButton>
                                </div>
                            </CCol>
                        </CRow>
    
    
                    </div>
                </CCard>
                <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                    <div class="p-2">
                        <CRow>
                            <CCol sm="9">
                                <h3 class="custom-18px-500 font-color-171717">Financial Policy</h3>
                            </CCol>
                            <CCol sm="3" class="text-right">
                                <CButton class="btn-border-blue font-color-0B63F6" @click="openPolicy"><img src="../assets/img/add-circle.png" style="max-width:20px" class="mr-1" />Create Financial Policy</CButton>
                            </CCol>
                        </CRow>
    
                        <hr class="custom-hr" />
                        <CRow>
                            <CCol sm="6">
                                <CRow>
                                    <CCol sm="10">
                                        <label class="custom-14px-500 font-color-171717 mt-1">Flight Tix <span class="custom-12px-500 font-color-98A2B3">(Unlimited)</span></label>
                                    </CCol>
                                    <CCol sm="2">
                                        <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                                    </CCol>
                                    <CCol sm="12">
                                        <hr class="custom-hr" />
                                    </CCol>
                                    <CCol sm="10">
                                        <label class="custom-14px-500 font-color-171717 mt-1">Parking <span class="custom-12px-500 font-color-98A2B3">(Unlimited)</span></label>
                                    </CCol>
                                    <CCol sm="2">
                                        <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                                    </CCol>
                                    <CCol sm="12">
                                        <hr class="custom-hr" />
                                    </CCol>
                                    <CCol sm="10">
                                        <label class="custom-14px-500 font-color-171717 mt-1">Meal <span class="custom-12px-500 font-color-98A2B3">(Unlimited)</span></label>
                                    </CCol>
                                    <CCol sm="2">
                                        <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                                    </CCol>
                                    <CCol sm="12">
                                        <hr class="custom-hr" />
                                    </CCol>
                                    <CCol sm="10">
                                        <label class="custom-14px-500 font-color-171717 mt-1">Hotel <span class="custom-12px-500 font-color-98A2B3">(Unlimited)</span></label>
                                    </CCol>
                                    <CCol sm="2">
                                        <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                                    </CCol>
                                    <CCol sm="12">
                                        <hr class="custom-hr" />
                                    </CCol>
                                </CRow>
                            </CCol>
                            <CCol sm="6">
                                <CRow>
                                    <CCol sm="10">
                                        <label class="custom-14px-500 font-color-171717 mt-1">Mileage (KM)<span class="custom-12px-500 font-color-98A2B3">(Unlimited)</span></label>
                                    </CCol>
                                    <CCol sm="2">
                                        <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                                    </CCol>
                                    <CCol sm="12">
                                        <hr class="custom-hr" />
                                    </CCol>
                                    <CCol sm="10">
                                        <label class="custom-14px-500 font-color-171717 mt-1">Medical (KM)<span class="custom-12px-500 font-color-98A2B3">(Unlimited)</span></label>
                                    </CCol>
                                    <CCol sm="2">
                                        <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                                    </CCol>
                                    <CCol sm="12">
                                        <hr class="custom-hr" />
                                    </CCol>
                                    <CCol sm="10">
                                        <label class="custom-14px-500 font-color-171717 mt-1">Others/Misc<span class="custom-12px-500 font-color-98A2B3">(Unlimited)</span></label>
                                    </CCol>
                                    <CCol sm="2">
                                        <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                                    </CCol>
                                    <CCol sm="12">
                                        <hr class="custom-hr" />
                                    </CCol>
                                    <CCol sm="10">
                                        <label class="custom-14px-500 font-color-171717 mt-1">Mileage (KM) - Motorcycle<span class="custom-12px-500 font-color-98A2B3">(Unlimited)</span></label>
                                    </CCol>
                                    <CCol sm="2">
                                        <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                                    </CCol>
                                    <CCol sm="12">
                                        <hr class="custom-hr" />
                                    </CCol>
    
                                </CRow>
                            </CCol>
                        </CRow>
                    </div>
                </CCard>
            </div>
    
            <div v-if="activeButton === 'Overtime'">
                <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                    <div class="p-2">
                        <h3 class="custom-18px-500 font-color-171717">Overtime Approval</h3>
                        <hr class="custom-hr" />
                        <CRow>
                            <CCol sm="5">
                                <label class="custom-14px-500 font-color-171717">First Level Approval</label>
                                <v-select></v-select>
                            </CCol>
                            <CCol sm="5">
                                <label class="custom-14px-500 font-color-171717">Second Level Approval</label>
                                <v-select></v-select>
                            </CCol>
                            <CCol sm="2">
                                <div class="text-right mt-4">
                                    <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="openAddCompany()">
                                        Save</CButton>
                                </div>
                            </CCol>
                        </CRow>
    
    
                    </div>
                </CCard>
                <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                    <div class="p-2">
                        <CRow>
                            <CCol sm="6">
                                <CRow>
                                    <CCol sm="6">
                                        <h3 class="custom-18px-500 font-color-171717">Overtime Policy</h3>
                                    </CCol>
    
                                    <CCol sm="6" class="text-right">
                                        <CButton class="btn-border-blue font-color-0B63F6" @click="openAddOvertimePolicy"><img src="../assets/img/add-circle.png" style="max-width:20px" class="mr-1" />Create Overtime Policy</CButton>
                                    </CCol>
                                </CRow>
                                <hr class="custom-hr" />
                                <CRow>
                                    <CCol sm="12">
                                        <CRow>
                                            <CCol sm="10">
                                                <label class="custom-14px-500 font-color-171717 mt-1">Normal Rate</label>
                                            </CCol>
                                            <CCol sm="2">
                                                <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                                            </CCol>
                                            <CCol sm="12">
                                                <hr class="custom-hr" />
                                            </CCol>
                                            <CCol sm="10">
                                                <label class="custom-14px-500 font-color-171717 mt-1">Rest Day Rate</label>
                                            </CCol>
                                            <CCol sm="2">
                                                <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                                            </CCol>
    
                                            <CCol sm="12">
                                                <hr class="custom-hr" />
                                            </CCol>
                                            <CCol sm="10">
                                                <label class="custom-14px-500 font-color-171717">Public Holiday Rate</label>
                                            </CCol>
                                            <CCol sm="2">
                                                <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                                            </CCol>
                                            <CCol sm="12">
                                                <hr class="custom-hr" />
                                            </CCol>
    
                                        </CRow>
                                    </CCol>
                                </CRow>
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-18px-500 font-color-171717">Overtime Setting</h3>
                                <CRow>
                                    <CCol sm="10">
                                        <label class="custom-14px-500 font-color-171717 mt-1">Count Overtime in Payroll</label>
                                    </CCol>
                                    <CCol sm="2">
                                        <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                                    </CCol>
                                    <CCol sm="12">
                                        <hr class="custom-hr" />
                                    </CCol>
                                    <CCol sm="12">
                                        <label class="custom-14px-500 font-color-171717">Working Days a Month</label>
                                        <v-select></v-select>
                                    </CCol>
                                    <CCol sm="12">
                                        <label class="custom-14px-500 font-color-171717 mt-2">Overtime Calculation</label>
                                        <v-select></v-select>
                                    </CCol>
                                    <CCol sm="12">
                                        <label class="custom-14px-500 font-color-171717 mt-2">Overtime Cut-off Date</label>
                                        <v-select></v-select>
                                    </CCol>
                                    <CCol sm="12">
                                <div class="text-right mt-4">
                                    <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="openAddCompany()">
                                        Save</CButton>
                                </div>
                            </CCol>
                                </CRow>
                            </CCol>
    
                        </CRow>
    
    
                    </div>
                </CCard>
            </div>
    
    
    
        </CCol>
    
        <div v-if="OpenAddClaimPolicy" class="popup-all backdrop-all">
            <div class="popup-all2">
                <CRow>
                    <CCol sm="10">
                        <h3 class="custom-24px-600 font-color-171717 text-left">Create Policy</h3>
                    </CCol>
                    <CCol sm="2" class="text-right"><img src="../assets/img/close.png" style="max-width:50px;" @click="closePopup" /></CCol>
                </CRow>
    
                <CCol sm="12" class="p-0">
                    <div class="p-2">
                        <CRow>
                            <CCol sm="12">
                                <CRow>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">Claim Name</h3>
                                        <v-select></v-select>
                                    </CCol>
                                    <CCol sm="6">
                                        <CRow>
                                            <CCol sm="6">
                                                <h3 class="custom-14px-500 font-color-171717">Mileage Based</h3>
                                            </CCol>
                                            <CCol sm="6">
                                                <CSwitch class="float-right mt-1" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" />
                                            </CCol>
                                        </CRow>
                                    </CCol>
                                    <CCol sm="12">
                                        <CRow class="mt-2">
                                            <CCol sm="6">
                                                <h3 class="custom-14px-500 font-color-171717">Annual Limit</h3>
    
                                                <CSelect></CSelect>
    
                                            </CCol>
                                            <CCol sm="6">
                                                <h3 class="custom-14px-500 font-color-171717">Limit per Application</h3>
    
                                                <CSelect></CSelect>
    
                                            </CCol>
                                            <CCol sm="12">
                                                <h3 class="custom-14px-500 font-color-171717">Exclude Employee</h3>
                                                <CInput type="text" />
    
                                                <h3 class="custom-14px-500 font-color-171717 mt-3">Claim Remarks</h3>
                                                <CInput type="text" />
                                            </CCol>
    
    
    
    
                                        </CRow>
                                    </CCol>
    
                                </CRow>
                            </CCol>
                        </CRow>
    
                        <div class="text-right">
                            <CRow>
                                <CCol sm="6">
                                    <CButton class="custom-grey-radius font-color-171717" @click="closePopup" block>Cancel</CButton>
                                </CCol>
                                <CCol sm="6">
                                    <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half" block>
                                        Add</CButton>
                                </CCol>
                            </CRow>
                        </div>
                        <br />
    
                    </div>
                </CCol>
            </div>
        </div>

        <div v-if="OpenAddOvertimePolicy" class="popup-all backdrop-all">
            <div class="popup-all2">
                <CRow>
                    <CCol sm="10">
                        <h3 class="custom-24px-600 font-color-171717 text-left">Create Overtime Policy</h3>
                    </CCol>
                    <CCol sm="2" class="text-right"><img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupOvertime" /></CCol>
                </CRow>
    
                <CCol sm="12" class="p-0">
                    <div class="p-2">
                        <CRow>
                            <CCol sm="12">
                                <CRow>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">Overtime Name</h3>
                                        <v-select></v-select>
                                    </CCol>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">Deducation Type</h3>
                                        <v-select></v-select>
                                    </CCol>
                                   
                                    <CCol sm="12">
                                        <CRow class="mt-2">
                                            <CCol sm="12">
                                                <h3 class="custom-14px-500 font-color-171717">Overtime Rate</h3>
    
                                                <CSelect></CSelect>
    
                                            </CCol>
                                            <CCol sm="12">
                                                <h3 class="custom-14px-500 font-color-171717">Included Employee</h3>
    
                                                <CSelect></CSelect>
    
                                            </CCol>
                                            <CCol sm="12">
                                                <h3 class="custom-14px-500 font-color-171717">Overtime Remark</h3>
                                                <CInput type="text" />
                                            </CCol>
    
    
    
    
                                        </CRow>
                                    </CCol>
    
                                </CRow>
                            </CCol>
                        </CRow>
    
                        <div class="text-right">
                            <CRow>
                                <CCol sm="6">
                                    <CButton class="custom-grey-radius font-color-171717" @click="closePopup" block>Cancel</CButton>
                                </CCol>
                                <CCol sm="6">
                                    <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half" block>
                                        Add</CButton>
                                </CCol>
                            </CRow>
                        </div>
                        <br />
    
                    </div>
                </CCol>
            </div>
        </div>
    
    
    
        <div v-if="isPopupSuccess" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width: 300px" src="../assets/img/successPopup.png" />
                    <h3 class="custom-28px-500 font-color-171717 text-center mt-3">
                        Your data has been submitted successfully.
                    </h3>
                    <CButton class="custom-border-purple mt-4 text-white" @click="closeSuccess" style="width:100px"><span class="ml-2 mr-2">OK</span></CButton>
                </div>
            </div>
        </div>
    
    
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";


import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';


export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        VueCal

    },

    data() {
        return {
            activeButton: 'Financial', // Default active button
            buttons: [
                { value: 'Financial', label: 'Financial', activeIcon: 'announce-white.png', inactiveIcon: 'announce-black.png' },
                { value: 'Overtime', label: 'Overtime', activeIcon: 'unread-white.png', inactiveIcon: 'unread-black.png' },
            ],

            options: {
                perPage: 5,
                pagination: true,
                searchable: true
            },

            OpenAddClaimPolicy: false,
            isPopupSuccess: false,

            OpenAddOvertimePolicy: false




        }





    },
    async mounted() {
        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                await this.GetInfoUser();



            } else {
                this.GoToPage();
            }
        } catch (error) {
            this.GoToPage();
            console.error("Error during authentication:", error);
            // Handle the error here
        }

    },

    computed: {

    },
    created() {},
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetCompanyDetails() {
            try {
                const response = await this.$API.get(this.$GetCompanyDetails, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.company = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetCompanyDetailsByInfo() {
            try {
                const response = await this.$API.get(this.$GetCompanyDetails, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.info = response.data;
                    console.log("userInfo", this.user);
                    if (response.status == 200 && this.info != null) {
                        this.FullName = this.info.name;
                        this.Address = this.info.Address;
                        this.City = this.info.City;
                        this.CompanyTypeName = this.info.CompanyTypeName;
                        this.Country = this.info.Country;
                        this.Email = this.info.Email;
                        this.Fax = this.info.Fax;
                        this.CompanyIndustryType = this.info.IndustryType;
                        this.LogoPath = this.info.LogoPath;
                        this.PhoneNumber = this.info.PhoneNumber;
                        this.Postcode = this.info.Postcode;
                        this.RegistrationNumber = this.info.RegistrationNumber;
                        this.ShortName = this.info.ShortName;
                        this.State = this.info.State;

                        this.SetupSelectedOption();
                    } else {
                        console.log(this.info.detail);
                    }

                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch company information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        closePopup() {
            this.OpenAddClaimPolicy = false;
        },
        openPolicy() {
            this.OpenAddClaimPolicy = true;
        },
        GoToPage() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },

        setActiveButton(buttonValue) {
            this.activeButton = buttonValue;
        },
        openAddOvertimePolicy() {
            this.OpenAddOvertimePolicy = true;
        },
        closePopupOvertime() {
            this.OpenAddOvertimePolicy = false;
        },
        GoToSetting()
        {
            this.$router.push("Setting");
        }





    }

};
</script>